import { Paper, Typography } from '@mui/material'
import { BomItemDimensionSummary } from 'features/BillOfMaterials/PartType/PartTypeDimensionSummary'
import { BomItemWorkingStepSummary } from 'features/BillOfMaterials/components/BomItemWorkingStepSummary'
import { useBomItemDetailsDialog } from 'features/BomItemDetailsDialog/useBomItemDetailsDialog'
import { useBomItemPointer } from 'features/BomItemDetailsDialog/useBomItemPointer'
import EngDrawingCarrousel from 'features/Drawings/PdfDrawings/Carrousel/EngDrawingCarrousel'
import { usePdfViewModel } from 'features/Drawings/PdfDrawings/usePdfViewModel'
import { BomItemType } from 'model/Project/BoMItemRow'
import moment from 'moment'
import { ProjectOperationDto } from 'services/APIs/InternalAPI/internal-api.contracts'

export function OperationPartTypeTooltip(props: {
  tooltip: string
  rowNumber: number
  bomItemName: string
  imageSrc: string
  operationGroup: ProjectOperationDto
  onPurchasingPriceClicked?: () => void
  engDrawingThumbnail?: string
}) {
  const bomItemPointer = useBomItemPointer(
    props.operationGroup.boMItemId,
    props.rowNumber ? BomItemType.partType : BomItemType.assemblyInstance,
  )

  const pdfViewModel = usePdfViewModel(
    bomItemPointer.id,
    null,
    props.operationGroup?.operationTypeTranslationKey ===
      'RecognizeEngineeringDrawing',
  )

  const openBomItemDetails = useBomItemDetailsDialog()

  const ImgComponent = () => {
    if (!props.engDrawingThumbnail && !props.imageSrc) {
      return null
    }

    if (
      props.operationGroup.operationTypeTranslationKey ===
        'RecognizeEngineeringDrawing' &&
      props.engDrawingThumbnail
    ) {
      return (
        <>
          <div
            style={{
              width: '100%',
              height: '250px',
              position: 'relative',
              overflow: 'clip',
            }}
          >
            <EngDrawingCarrousel
              bomItemPointer={bomItemPointer}
              pdfViewModel={pdfViewModel.pdfViewModel}
              setPdfViewerModel={pdfViewModel.setPdfViewModel}
              loading={pdfViewModel.loading}
              initialImageSrc={pdfViewModel.pdfViewModel?.pages?.[0]?.image}
              disableToolbox
            />
          </div>
        </>
      )
    }

    return (
      <img
        alt={props.bomItemName?.toString()}
        src={props.imageSrc}
        style={{
          height: '200px',
          width: '200px',
        }}
        loading="lazy"
      />
    )
  }

  return (
    <Paper className={props.tooltip} elevation={0}>
      {Boolean(props.rowNumber) && (
        <Typography variant="caption" component="span">
          {props.rowNumber}
        </Typography>
      )}
      <Typography variant="body1" component="span">
        {props.bomItemName ||
          props.operationGroup.operationTypeTranslationArguments?.[0]}
      </Typography>
      {ImgComponent()}
      {props.operationGroup.boMItemId && (
        <>
          <BomItemDimensionSummary
            bomItemPointer={bomItemPointer}
            typographyProps={{
              variant: 'caption',
              whiteSpace: 'pre',
            }}
          />
          <BomItemWorkingStepSummary bomItemPointer={bomItemPointer} />
        </>
      )}
      <Typography variant="caption">
        {props.operationGroup.status} |{' '}
        {moment(props.operationGroup.lastUpdatedAt).format('L HH:mm:ss')}
      </Typography>
      {props.operationGroup.errorMessage && (
        <Typography variant="body2" color="secondary">
          {props.operationGroup.errorMessage}
        </Typography>
      )}
    </Paper>
  )
}
